<template>
  <div>
    <!-- {{ dataType }} -->
    <div class="page-title-wrapper">
      <template v-if="tableMeta && tableMeta.title || $route.meta.title">
        <h1 v-if="tableMeta.headingIcon" class="page-title">
          <i :class="getIconClass()"></i> {{ getTitle() }}
        </h1>
        <h1 v-else class="page-title">{{ getTitle() }}</h1>
      </template>

      <table-actions
        class="page-title-buttons"
        :data-type="dataType"
        :table-meta="tableMeta"
        :filter="data.filter"
        :filter-meta="filterMeta"
        @tableControlAction="tableControlAction"
        @tableAction="tableAction"
        @resetFilter="resetFilter" />
    </div>

    <div class="table-layout">
      <table class="table is-striped is-hoverable is-fullwidth" v-if="data.items && data.items.length > 0">
        <table-head :filter="data.filter" :column-meta="columnMeta" :showContextMenu="contextMenu"></table-head>
        <table-body :items="data.items" :column-meta="columnMeta" :action-meta="actionMeta" @rowAction="rowAction" @fieldAction="fieldAction" :showContextMenu="contextMenu"></table-body>
      </table>
    </div>

    <div class="card-layout">
      <card-list
        :items="data.items"
        :column-meta="columnMeta"
        :action-meta="actionMeta"
        :showContextMenu="contextMenu"
        @rowAction="rowAction"
        @fieldAction="fieldAction"
      />
    </div>

    <div class="loader-wrapper" v-if="data.loading">
      <div class="loader"></div>
    </div>

    <table-pagination
      v-if="!tableMeta.hidePagination"
      :loading="data.loading"
      :meta="data.meta"
      :dataType="dataType" />
  </div>
</template>

<script>

import TableActions from '@/components/table/AgileTableActions'
import TableFilters from '@/components/table/AgileTableFilters'
import TableHead from '@/components/table/AgileTableHead'
import TableBody from '@/components/table/AgileTableBody'
import TablePagination from '@/components/table/AgileTablePagination'
import CardList from '@/components/table/CardList'

export default {
  name: 'agile-table',
  components: {
    TableActions,
    TableFilters,
    TableHead,
    TableBody,
    TablePagination,
    CardList
  },
  props: {
    dataType: {
      type: String,
      required: true
    },
    data: {
      type: Object,
      required: false
    },
    tableMeta: {
      type: Object,
      required: false,
      default () {
        return {
          hidePagination: false
        }
      }
    },
    filterMeta: {
      type: Array,
      required: false
    },
    actionMeta: {
      type: Object,
      required: false
    },
    columnMeta: {
      type: Object,
      required: false
    },
    showContextMenu: {
      type: Boolean,
      required: false
    },
    loading: {
      type: Boolean,
      required: false
    }
  },
  computed: {
    contextMenu () {
      return this.showContextMenu
    }
  },
  methods: {
    getTitle () {
      if (this.tableMeta.title) {
        return this.tableMeta.title
      }
      return this.$route.meta.title
    },

    getIconClass () {
      if (this.tableMeta.headingIcon) {
        return 'fal ' + this.tableMeta.headingIcon
      }
      return null
    },

    rowAction (action, item) {
      this.$emit('rowAction', action, item)
    },

    fieldAction (action, item) {
      this.$emit('fieldAction', action, item)
    },

    tableAction (action) {
      this.$emit('tableAction', action)
    },

    tableControlAction (control) {
      this.$emit('tableControlAction', control)
    },

    resetFilter () {
      this.$emit('resetFilter')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/table/AgileTable.vue